import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { sessionReducer as session } from './session';
import { devicesReducer as devices } from './devices';
import { positionsReducer as positions } from './positions';
import { geofencesReducer as geofences } from './geofences';
import { groupsReducer as groups } from './groups';
import { driversReducer as drivers } from './drivers';
import { maintenancesReducer as maintenances } from './maintenances';
import { organizationReducer as organization_information } from "./organizationInfo";
import { devicesSelectedReducer as devicesSelected} from "./devicesSelected";
import { notificationsReducer as notifications } from "./notifications";
import { languageReducer as language } from "./language";
import { periodReducer as period} from "./period";
import { themeReducer as theme} from "./theme"

const reducer = combineReducers({
  session,
  devices,
  positions,
  geofences,
  groups,
  drivers,
  maintenances,
  organization_information,
  devicesSelected,
  notifications,
  language,
  period,
  theme,
});

export { sessionActions } from './session';
export { devicesActions } from './devices';
export { positionsActions } from './positions';
export { geofencesActions } from './geofences';
export { groupsActions } from './groups';
export { driversActions } from './drivers';
export { maintenancesActions } from './maintenances';
export { organizationActions } from './organizationInfo';
export { devicesSelectedActions } from './devicesSelected';
export { notificationsActions } from './notifications';
export { languageActions } from './language';
export { periodActions } from './period'
export { toggleTheme } from './theme';

export default configureStore({ reducer });
